import React from "react";
import PropTypes from "prop-types";
import { Flex, Input, Text } from "@fluentui/react-northstar";

const LabelTextInput = (props) => {
  const {
    label,
    placeholder,
    testId,
    onChange,
    disabled,
    value,
    className,
  } = props;

  return (
    <Flex column fill>
      <Text
        className="body-text"
        data-testid={testId + "Title"}
        content={label}
      />
      <Input
        placeholder={placeholder}
        data-testid={testId + "Input"}
        className={className ? className + "-input" : ""}
        onChange={onChange}
        fluid
        disabled={disabled}
        value={value}
      />
    </Flex>
  );
};

LabelTextInput.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  testId: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

LabelTextInput.defaultProps = {
  value: "",
  placeholder: "",
  testId: "",
  label: "",
  disabled: false,
  className: "",
};

export default LabelTextInput;
